import React from "react";
import PropTypes from "prop-types";

const getInitials = (name = "") => {
    if (!name) return "";
    const parts = name.trim().split(" ");
    if (parts.length === 1) return parts[0][0]?.toUpperCase() || "";
    return (parts[0][0] + parts[1][0]).toUpperCase();
};

const Avatar = ({
    src,
    alt = "",
    shape = "circle",
    size = 40,
    name = "",
    style = {},
    className = "",
    ...rest
}) => {
    const isCircle = shape === "circle";
    const borderRadius = isCircle ? "50%" : "8px";
    const isArray = Array.isArray(size);
    const width = isArray ? size[0] : size;
    const height = isArray ? size[1] : size;
    const fontSize = Math.min(width, height) * 0.4;
    const placeholder = getInitials(name) || (
        <svg width={width * 0.6} height={height * 0.6} viewBox="0 0 32 32" fill="#bdbdbd">
            <circle cx="16" cy="12" r="8" />
            <rect x="6" y="22" width="20" height="6" rx="3" />
        </svg>
    );

    return (
        <div
            className={`custom-avatar ${className}`}
            style={{
                width,
                height,
                borderRadius,
                background: "#f0f0f0",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: 600,
                fontSize,
                color: "#555",
                overflow: "hidden",
                ...style
            }}
            {...rest}
        >
            {src ? (
                <img
                    src={src}
                    alt={alt || name}
                    style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        borderRadius,
                        display: "block"
                    }}
                />
            ) : (
                placeholder
            )}
        </div>
    );
};

Avatar.propTypes = {
    src: PropTypes.string,
    alt: PropTypes.string,
    shape: PropTypes.oneOf(["circle", "square"]),
    size: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.arrayOf(PropTypes.number)
    ]),
    name: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string
};

export default Avatar;